const getImagePlaceholder = () => {
  return "https://yakihonne.s3.ap-east-1.amazonaws.com/media/images/thumbnail_placeholder.png";
};

export { getImagePlaceholder };
